import axios from '_u/axios'

// var wsNotifyAxios =  axios.create()

// wsNotifyAxios.interceptors.response.use( )

// wsNotifyAxios.post()

// 账单生成
export const contractBillCreate = (body) => {
    return axios.post('api/bill/info/genBillInfo', body)
}

// 根据合同与费用清算生成账单
export const expenseBillListCreate = (body) => {
    var count = 1000
    return axios.post('api/bill/info/liquidation', body).then((res) => {
        // @bugfix 存在id为null的数据，前端补上，以免引起可编辑表格的各种问题
        res.data.list.forEach((v) => {
            if (v.id === null) v.id = '' + count++
        })

        return res
    })
}

// 根据合同查询账单
export const contractBillListCreate = (body) => {
    return axios.post('api/bill/info/listByContract', body)
}

// 根据合同查询读数
export const houseMeterList = (houseId) => {
    return axios.post('api/assets/housemeter/queryByHouse', { houseId })
}

// 批量保存或更新抄表记录
export const meterListUpdate = (meters) => {
    return axios.post('api/assets/housemeter/batchSaveOrUpdate', { meters })
}

// 合同预览
export const contractPriview = (body) => {
    return axios.post('api/contract/info/priviewContract', body)
}

// 合同列表
export const contractList = (body) => {
    return axios.post('api/contract/info/list', body)
}

// 合同详情
export const contractView = (id) => {
    return axios.post('api/contract/info/view', { id })
}

// 合同 根据房间id查询
export const getContractByHouse = (houseId) => {
    return axios.post('api/contract/info/queryByHouse', { houseId })
}

// 合同新增
export const contractAdd = (body) => {
    return axios.post('api/contract/info/add', body)
}

// 合同附件上传
export const contractUpdateAttach = (body) => {
    return axios.post('api/contract/lease/updateAttach', body)
}

// 合同保存
export const contractSave = (id) => {
    return axios.post('api/contract/info/saveContractFile', { id })
}

// 合同续租
export const contractRelet = (body) => {
    return axios.post('api/contract/info/relet', body)
}

// 合同换房
export const contractChangeHouse = (body) => {
    return axios.post('api/contract/info/changeHouse', body)
}

// 合同退租
export const contractCancelRent = (body) => {
    return axios.post('api/contract/info/cancelRent', body)
}

// 合同历史 清算明细
export const contractLiquidationDetail = (id) => {
    return axios.post('api/contract/info/liquidationDetail', { id })
}

// 合同作废
export const contractInvalid = (id) => {
    return axios.post('api/contract/info/invalid', { id })
}

// 合同修改
export const contractUpdate = (body) => {
    return axios.post('api/contract/info/update', body)
}

// 修改租客信息
export const cusUpdate = (body) => {
    return axios.post('api/contract/cus/update', body)
}

//   修改记录列表
export const updatelogList = (body) => {
    return axios.post('api/contract/updatelog/list', body)
}

//   修改记录详情
export const updatelogView = (id) => {
    return axios.post('api/contract/updatelog/view', { id })
}

//   查看租客详情
export const cusView = (id) => {
    return axios.post('api/contract/cus/view', { id })
}

// 物品清单修改
export const contractFacilityUpdate = (body) => {
    return axios.post('api/contract/facility/update', body)
}

// 获取账期/账期内月份数据
export const getPeriods = (body) => {
    return axios.post('api/bill/info/getPeriods', body)
}

// 判断退租类型
export const queryCancelRentType = (contractId) => {
    return axios.post('api/bill/info/queryCancelRentType', { contractId })
}

// 查询新合同
export const relContract = (id) => {
    return axios.post('api/contract/info/relContract', { id })
}

// 合同发邮件给租客
export const mailContract = (body) => {
    // email
    // contractId
    return axios.post('/api/contract/info/mail', body)
}
